angular.module("app.version", [])
.constant("VersionInfo", {"version":"2.6.0","timestamp":"2024-12-03T12:12:35Z","revision":"df36d38","nickname":"empty-discussion","env":"generic"});
